// Message channels are how a user TALKS TO the agent (WhatsApp, Telegram, Slack,
// Teams, Discord), a separate concept from integrations/tools. This mirrors the
// /api/channels/{tenantId} wire shape.

export type ChannelStatus = "active" | "pending" | "requested" | "disconnected";

export type ChannelAccount = {
  alias: string | null;
  status: ChannelStatus;
  accountLabel: string | null;
};

export type ChannelConnection = {
  channel: string;
  status: ChannelStatus;
  accountLabel: string | null;
  requestedBy: string | null;
  accounts: ReadonlyArray<ChannelAccount>;
  // Connected, but the latest health check shows the link gone (WhatsApp
  // unlinked the device). The dashboard offers Reconnect.
  needsReconnect: boolean;
};

type ApiChannelAccount = {
  alias: string | null;
  status: string;
  accountLabel: string | null;
};

type ApiChannelConnection = {
  channel: string;
  status: string;
  accountLabel: string | null;
  requestedBy: string | null;
  accounts?: ReadonlyArray<ApiChannelAccount>;
  needsReconnect?: boolean;
};

const asStatus = (s: string): ChannelStatus =>
  s === "active" || s === "pending" || s === "requested" || s === "disconnected"
    ? s
    : "pending";

export const channelFromApi = (raw: ApiChannelConnection): ChannelConnection => ({
  channel: raw.channel,
  status: asStatus(raw.status),
  accountLabel: raw.accountLabel,
  requestedBy: raw.requestedBy,
  accounts: (raw.accounts ?? []).map((a) => ({
    alias: a.alias,
    status: asStatus(a.status),
    accountLabel: a.accountLabel,
  })),
  needsReconnect: raw.needsReconnect === true,
});
